import React, {useContext} from 'react';

import UserContext from '../UserContext';
import ReviewFinalScreen from './ReviewFinalScreen';
import MobileNavBar from '../headers/MobileNavBar';
import ConsentFlowHeader from '../headers/ConsentFlowHeader';
import StatusBarCompletion from '../status/StatusBarCompletion';
import MobileNavControls from '../controls/MobileNavControls';

import FUTURE_ACCOUNT_STR from '../../data/FutureAccountString';

export default function WrappedReviewScreen(props) {
  const userContext = useContext(UserContext);

  return (
    <div>
      <MobileNavBar url="chase.com" />
      <div className="preview-app-body row border-gray">
        <div className="container-fluid">
          <ConsentFlowHeader />
          <StatusBarCompletion
            numSteps={4}
            currentIndex={3} />
          <div className="row py-2">
            <div className="col-sm-10 offset-sm-1">
              <ReviewFinalScreen
                goBack={props.goBack}
                client={userContext.client}
                selectedAccounts={userContext.selectedAccounts.filter(a => a.name !== FUTURE_ACCOUNT_STR)} />
            </div>
          </div>
          <MobileNavControls
            scrollCentralPane={props.scrollCentralPane}
            section='confirm-accounts'
            goBack={props.goBack}
            goNext={props.goNext}
            dataPtName="review"
            nextButtonText="Connect" />
        </div>
      </div>
    </div>
  );
}
